import classNames from 'classnames';

import { Link, type GeneralLinkProps } from './link';

export const TextLink = ({ className, ...props }: GeneralLinkProps) => {
  return (
    <Link
      {...props}
      className={classNames(
        'underline',
        {
          'text-(--mui-palette-text-disabled)': props.disabled,
          'text-(--mui-palette-text-primary) hover:text-(--mui-palette-text-secondary)':
            !props.disabled,
        },
        className
      )}
    >
      {props.children}
    </Link>
  );
};
